<template>
    <div class="form-box">
        <div class="form-title">
            <div class="title-reg">注册帐号</div>
            <div class="title-pass" @click="sendLogin">
                已有帐号 <span>点击登录</span>
            </div>
        </div>
        <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" class="demo-ruleForm">
            <el-form-item prop="mobile">
                <div class="input-div">
                    <img class="input-icon" src="../assets/down-phone.png" alt="" />
                    <el-input v-model="ruleForm.mobile" placeholder="请输入手机号"></el-input>
                </div>
            </el-form-item>
            <el-form-item prop="code">
                <div class="input-div">
                    <img class="input-icon newCode" src="../assets/login-code.png" alt="" />
                    <el-input v-model="ruleForm.code" placeholder="请输入验证码">
                        <template slot="append">
                            <div @click="sendsms" v-if="setTime">
                                发送验证码
                            </div>
                            <div v-else>{{ timeNum }}</div>
                        </template></el-input>
                </div>
            </el-form-item>
            <el-form-item prop="userPassword">
                <div class="input-div">
                    <img class="input-icon newPass" src="../assets/login-pass.png" alt="" />
                    <el-input v-model="ruleForm.userPassword" type="password" placeholder="请设置登录密码"></el-input>
                </div>
            </el-form-item>
            <el-form-item prop="newPassword">
                <div class="input-div">
                    <img class="input-icon newPass" src="../assets/login-pass.png" alt="" />
                    <el-input v-model="ruleForm.newPassword" placeholder="请再次输入密码" type="password"></el-input>
                </div>
            </el-form-item>
            <el-form-item>
                <div class="but-div">
                    <el-button type="primary" class="submitBut" @click="submitForm('ruleForm')">注册</el-button>
                </div>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import { sendsmsApi, pcregApi } from "../api/api.js";
import { MD5 } from "crypto-js";
export default {
    name: "",
    props: ["sendData"],
    data() {
        var checkMobile = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("手机号不能为空"));
            } else {
                const phoneRegex = /^1[3-9]\d{9}$/;
                if (phoneRegex.test(value)) {
                    callback();
                } else {
                    callback(new Error("请输入正确的手机号"));
                }
            }
        };
        var validatePass = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入密码"));
            } else {
                callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请再次输入密码"));
            } else if (value !== this.ruleForm.userPassword) {
                callback(new Error("两次输入密码不一致!"));
            } else {
                callback();
            }
        };
        return {
            ruleForm: {
                mobile: "",
                code: "",
                userPassword: "",
                newPassword: "",
            },
            rules: {
                mobile: [
                    {
                        validator: checkMobile,
                        trigger: "blur",
                    },
                ],
                code: [
                    {
                        required: true,
                        message: "请输入验证码",
                        trigger: "blur",
                    },
                ],
                userPassword: [
                    {
                        validator: validatePass,
                        trigger: "blur",
                    },
                ],
                newPassword: [
                    {
                        validator: validatePass2,
                        trigger: "blur",
                    },
                ],
            },

            timeNum: 60,
            setTime: true,
        };
    },
    components: {},
    methods: {
        sendLogin() {
            this.sendData(true);
        },
        async sendsms() {
            this.countdown();
            const res = await sendsmsApi({
                mobile: this.ruleForm.mobile,
            });
        },
        // 更新倒计时的函数
        countdown() {
            this.setTime = false;

            // 每秒更新一次倒计时
            this.timer = setInterval(() => {
                this.timeNum = this.timeNum - 1;

                // 当倒计时结束时清除定时器
                if (this.timeNum <= 0) {
                    clearInterval(this.timer);
                    this.setTime = true; // 允许重新开始
                }
            }, 1000); // 每1000毫秒（1秒）执行一次
        },
        submitForm() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.pcreg();
                } else {
                    // console.log("error submit!!");
                    return false;
                }
            });
        },
        async pcreg() {
            this.ruleForm.userPassword = MD5(
                this.ruleForm.userPassword
            ).toString();
            const res = await pcregApi(this.ruleForm);
            if (res?.data?.resp_code == 0) {
                this.$message({
                    message: "注册成功",
                    type: "success",
                });
                this.sendLogin();
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.form-box {
    margin: 40px;

    .form-title {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .title-reg {
            font-size: 26px;
            color: #fff;
            font-weight: bold;
        }

        .title-pass {
            font-size: 16px;
            color: #938e8e;

            span {
                color: #ff9000;
                cursor: pointer;
            }
        }
    }

    .demo-ruleForm {
        margin-top: 50px;
    }

    .but-div {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 20px;
    }

    .submitBut {
        background: #ff9000;
        border: 1px solid #ff9000;
        color: #000;
        font-size: 18px;
        font-weight: bold;
        width: 215px;
    }

    .input-div {
        display: flex;
        align-items: center;

        .input-icon {
            width: 30px;
            height: 43px;
            position: absolute;
            left: 10px;
            /* 根据需要调整 */
            top: 50%;
            transform: translateY(-50%);
            z-index: 1;
            /* 确保图标在输入框上方 */
        }

        .newCode {
            width: 27px;
            height: 31px;
        }

        .newPass {
            width: 25px;
            height: 33px;
        }
    }
}

::v-deep .el-input__inner {
    background: #474545;
    border: 1px solid #474545;
    color: #fff;
    padding: 30px 0;
    padding-left: 60px;
    height: 50px;
}

::v-deep .el-input-group__append {
    background: #474545;
    border: 1px solid #474545;
    cursor: pointer;
    color: #fff;
}
</style>
